// Translation: Account > Integrations > Access keys > Access key deletion dialog (English)
export default Object.freeze({
	actions: {
		cancel: 'Cancel',
		delete: 'Delete'
	},
	message: {
		text: 'Are you sure you want to delete this access key?',
		title: 'Access key will be deleted'
	}
})
